import { useState } from 'react';

const useIsWidgetExpanded = (appId) => {
	const [isWidgetExpanded, setIsWidgetExpanded] = useState(false);

	const overriddenSetIsWidgetExpanded = (value) => {
		localStorage.setItem('kodifMinimized' + appId, String(!value));
		setIsWidgetExpanded(value);
	};

	return [isWidgetExpanded, overriddenSetIsWidgetExpanded];
};

export default useIsWidgetExpanded;